import React from 'react'

import AssessmentQuestion from 'components/Assessment/AssessmentQuestion'
import Button from 'components/Common/Button'
import QuestionsContainerStyle from 'components/Common/QuestionBox'
import { GuideWrapper } from '../style'

const PlayQuestion = ({ hideButton, playStage, disablePlay, body, moveNext, height, id = '' }) => {
  return (
    <>
      <GuideWrapper id={id}>
        <QuestionsContainerStyle height={height} playQuestion={true}>
          <AssessmentQuestion
            hideButton={hideButton}
            disable={playStage.isCompleted && disablePlay}
            userId={''}
            onSubmit={''}
            assessmentType={''}
            activeQuestion={body}
            uploadFileAction={''}
            setActiveQuestion={() => {}}
            assessmentResponse={null}
            saveAssessmentResponseAction={() => {}}
            uploadFileLoading={''}
            playQuestion={true}
            isPlay={true}
          />
        </QuestionsContainerStyle>
      </GuideWrapper>
      {/* .....why does the prop "hideButton" show a button? */}
      {hideButton && (
        <div className="flex justify-center mt-4">
          <div className="w-full sm:w-auto">
            <Button
              label={body?.options[0]?.value}
              disabled={disablePlay}
              onClick={moveNext}
              className="w-full"
              variant="primary"
              testId="button"
            />
          </div>
        </div>
      )}
    </>
  )
}

export default PlayQuestion
